import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import styles from '../shared/ProgressReport.module.scss';
import { Pagination } from "../../assets/Pagination/Pagination";
import { Spinner } from 'react-bootstrap';
import NoData from '../../assets/NoData/NoData';

const LessonPlan = ({

    getAcademicPeriod,
    getCoursesList,
    coursesList,
    fetchFacultyList,
    facultyList,
    fetchCourse,
    disciplineRPD,
    fetchMetaCourse,
    discipline,
    getYears,
    getLessonPlan,
    lessonPlanList,
    pagesCount,
    isLoading,
    years = [],

    getLessonPlanByYearAndFuk,
    lessonPlanListCur,

    termLessonPlan,
    getLessonPlanTerm,

    ...props
}) => {

    const [disabled, setDisabled] = useState(true)
    const [list, setList] = useState([])
    const [state, setState] = useState({
        discipline: 0,
        disciplineRPD: 0,
        faculty: 0,
        semester: 0,
        year: 0,
        curriculum: 0,
        kurs: 0,
        numberPage: null,
    });

    const isYearSelected = state.year && state.year != 0;
    
    useEffect(() => {
        getCoursesList()
        fetchFacultyList()
        getYears()
        fetchCourse({ xp_key: state.year })
        fetchMetaCourse(state.year, 0, 0)
        getLessonPlanTerm(state)
        // getLessonPlan(state)
    }, []);

    useEffect(() => {
        state.year &&
            fetchCourse({ xp_key: state.year, idcurriculum: state.curriculum })

    }, [state.year])


    useEffect(() => {
        termLessonPlan?.length && setState(prev => ({ ...prev, term: termLessonPlan[0].trmid }))
    }, [termLessonPlan])

    useEffect(() => {
        // Кнопка "Обновить" доступна только после выбора учебного года
        if (state.year > 0) {
            setDisabled(false);
            // Загружаем список учебных планов для фильтра
            getLessonPlanByYearAndFuk(state.year, state.faculty || 0);
        } else {
            setDisabled(true);
        }
    }, [state.year, state.faculty])

    useEffect(() => {
        getLessonPlanTerm(state)

    }, [state.year, state.faculty, state.curriculum, state.kurs])

    useEffect(() => {
        const { year } = state
        year && getAcademicPeriod(year)
        fetchMetaCourse(state.year, state.curriculum, state.curriculum)
    }, [state.year]);

    useEffect(() => {
        fetchCourse({ xp_key: state.year, idcurriculum: state.curriculum })
        fetchMetaCourse(state.year, state.curriculum, state.curriculum)
    }, [state.curriculum]);

    useEffect(() => {
        state.numberPage !== null && getLessonPlan(state)
    }, [state.numberPage]);

    useEffect(() => {
        const { disciplineRPD } = state
        fetchMetaCourse(state.year, state.curriculum, disciplineRPD)
    }, [state.disciplineRPD]);

    useEffect(() => {
    }, [state.discipline]);

    const handleSelectorChange = (e) => {
        const { name, value } = e.target
        setState({ ...state, [name]: value })
    };

    useEffect(() => {  //set years and reverse 
        setList(years?.reverse())
    }, [years])

    const renderEducationProgramsTable = (plan, index) => (
        <tr key={index} className="pointer">
            <td>{plan["subject"]}</td>
            <td>{plan["cname"]}</td>
            <td>{plan["course_number"]}</td>
            <td>{plan["semester"]}</td>
            <td>{plan["hours"]}</td>
        </tr>
    );

    return (
        <div className="27jpg">
            <div className="captions">Планы проведения занятий</div>

            <div className={styles.selectors}>

                <div className={styles.selectorsRight}>
                    <div>
                        <label>
                            Учебный год:
                        </label>
                        <select
                            name='year'
                            onChange={handleSelectorChange}
                            value={state.year}
                        >
                            <option value='0'>Выберите</option>
                            {list && list.length > 0 && list.map(c =>
                            (<option key={c.xp_key} value={c.xp_key}>
                                {c.name}
                            </option>))
                            }
                        </select>
                    </div>
                    <div>
                        <label>
                            Учебный план:
                        </label>
                        <select
                            name='curriculum'
                            onChange={handleSelectorChange}
                            value={state.curriculum}
                            disabled={!isYearSelected}
                        >
                            <option value='0'>Все</option>
                            {lessonPlanListCur && lessonPlanListCur.map(c => <option key={c.idcurriculum} value={c.idcurriculum}>
                                {c.cname}
                            </option>
                            )}
                        </select>
                    </div>
                    <div>
                        <label>
                            Дисциплина РПД:
                        </label>
                        <select
                            name='disciplineRPD'
                            onChange={handleSelectorChange}
                            value={state.disciplineRPD}
                            disabled={!isYearSelected}
                        >
                            <option value='0'>Все</option>
                            {disciplineRPD && disciplineRPD.map(f => (
                                <option key={f.cid} value={f.cid}>
                                    {f.predmet}
                                </option>
                            ))
                            }
                        </select>
                    </div>



                </div>

                <div className={styles.selectorsLeft} style={{ width: '53%' }}>
                    <div>
                        <label>
                            Факультет:
                        </label>
                        <select
                            name='faculty'
                            onChange={handleSelectorChange}
                            value={state.faculty}
                            disabled={!isYearSelected}
                        >
                            <option value='0'>Все</option>
                            {facultyList && facultyList.map(f => (
                                <option key={f.idfaculty} value={f.idfaculty}>
                                    {f.faculty}
                                </option>
                            ))
                            }
                        </select>
                    </div>
                    <div>
                        <div>
                            <label>
                                Курс:
                            </label>
                            <select
                                name='kurs'
                                onChange={handleSelectorChange}
                                value={state.kurs}
                                style={{ width: "150px" }}
                                disabled={!isYearSelected}
                            >
                                <option value='0'>Все</option>
                                {coursesList && coursesList.map(c => (<option key={c.eyid} value={c.eyid}>
                                    {c.name}
                                </option>))
                                }
                            </select>
                        </div>
                        <div>
                            <label>
                                Семестр:
                            </label>
                            <select
                                name='semester'
                                onChange={handleSelectorChange}
                                value={state.semester}
                                style={{ width: '220px' }}
                                disabled={!isYearSelected}
                            >
                                <option value='0'>Все</option>
                                {termLessonPlan && termLessonPlan.map(c => (<option key={c.tlid} value={c.tlid}>
                                    {c.name}
                                </option>))
                                }
                            </select>
                        </div>
                    </div>
                    <div>
                        <label>
                            Дисциплина:
                        </label>
                        <select
                            name='discipline'
                            onChange={handleSelectorChange}
                            value={state.discipline}
                            disabled={!isYearSelected}
                        >
                            <option value='0'>Все</option>
                            {discipline?.map(c => (<option key={c.idmetacourse} value={c.idmetacourse}>
                                {c.name}
                            </option>))}
                        </select>
                    </div>
                </div>
            </div>
            <button
                className={!disabled ? styles.updateButton : styles.updateButtonDisabled}
                disabled={disabled}
                onClick={() => getLessonPlan(state)}
            >
                Обновить
            </button>

            <Pagination
                pageCount={pagesCount}
                numberPage={state.numberPage}
                onPageChange={(page) => setState({ ...state, numberPage: page.selected })}
            />

            {isLoading ? (
                <div className="text-center">
                    <br />
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            ) : (lessonPlanList?.lesson_plans && lessonPlanList?.lesson_plans.length > 0 ?
                <table className="umkT-table mt-10">
                    <thead>
                        <tr>
                            <th>Дисциплина</th>
                            <th>Учебный план</th>
                            <th>Курс</th>
                            <th>Семестр</th>
                            <th>Всего</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lessonPlanList?.lesson_plans?.map(renderEducationProgramsTable)}
                    </tbody>
                </table> : <NoData text='данные отсутствуют' />
            )}
            <Pagination
                pageCount={pagesCount}
                numberPage={state.numberPage}
                onPageChange={(page) => setState({ ...state, numberPage: page.selected })}
            />

        </div>
    );
}


export default LessonPlan;